<template>
  <div class="palettes-container">
    <transition name="fade">
      <DDR v-if="isDDROpen" />
    </transition>
    <div class="palettes-content">
      <Header />
      <transition
        name="fadeHeight"
        mode="out-in"
      >
        <Welcome
          v-if="!hideWelcome"
          v-on:closeWelcome="closeWelcome"
        />
      </transition>
      <a
        v-if="hideWelcome  && visitCount < 3 && false"
        target="_blank"
        href="https://www.producthunt.com/posts/flat-ui-colors-2"
        class="ph2"
        @click="$ga.event('ph-click');"
      >
        🚀&nbsp;&nbsp;&nbsp;💛 &nbsp;&nbsp;&nbsp;Don't forget to share your love & comment on Product Hunt! &nbsp;&nbsp;&nbsp;💬&nbsp;&nbsp;&nbsp; ❤️
      </a>
      <div
        class="small-palettes"
        v-for="(paletteChunk, index) in paletteChunks"
        :key="`paletteChunk${index}`"
      >
        <SmallPalette
          @click.native="$ga.event('palette', palette.id);"
          class="small-palette"
          v-for="(palette, chunkIndex) in paletteChunk"
          :chunkIndex="chunkIndex"
          :key="palette.id"
          :palettes="palettes"
          :palette-id="palette.id"
        />
        <Promoter
          @click.native="tweetClick()"
          v-if="index == 4 && visitCount > -1 && !tweetClicked"
          class="ph2"
        ></Promoter>
        <PandaBar
          v-if="index == 0 && visitCount > -1"
          class="pandabar"
        ></PandaBar>
      </div>
      <br>
      <a
        v-if="!hideWelcome && false"
        target="_blank"
        href="https://www.producthunt.com/posts/flat-ui-colors-2"
        class="ph2"
        @click="$ga.event('ph-click');"
      >
        🚀&nbsp;&nbsp;&nbsp;💛 &nbsp;&nbsp;&nbsp;It's launch day! If you like it don't forget to share your love & comment on Product Hunt! &nbsp;&nbsp;&nbsp;💬&nbsp;&nbsp;&nbsp; ❤️
      </a>
      <MoreProducts />
    </div>
    <Footer />
  </div>
</template>

<script>
// import router from "@/router";
import Header from "@/components/Header";
import SmallPalette from "@/components/SmallPalette";
import Footer from "@/components/Footer";
import MoreProducts from "@/components/MoreProducts";
import Welcome from "@/components/Welcome";
import Promoter from "@/components/Promoter";
import PandaBar from "@/components/PandaBar";
import DDR from "@/components/DDR";
import _ from "lodash";
import cloneDeep from "lodash.clonedeep";
import { mapState, mapMutations } from "vuex";
// import favicon from "favicon.js";
let palettes = require("@/data/palettes.json");

let isMobile = false;

if (
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/iPad/i) ||
  navigator.userAgent.match(/BlackBerry/i) ||
  navigator.userAgent.match(/IEMobile/i) ||
  navigator.userAgent.match(/Opera Mini/i)
) {
  isMobile = true;
}

export default {
  name: "Palettes",
  components: {
    Header,
    SmallPalette,
    Footer,
    MoreProducts,
    Welcome,
    Promoter,
    PandaBar,
    DDR,
  },
  data() {
    return {
      palettes,
      paletteChunks: [],
      hideWelcome: false,
      visitCount: 0,
      tweetClicked: 0,
      isMobile,
    };
  },
  computed: {
    ...mapState(["isDDROpen"]),
  },
  metaInfo: {
    title: "Palettes",
  },
  beforeMount() {
    $crisp.push(["do", "chat:hide"]);
    // console.log("showWelcome", localStorage.getItem("hideWelcome"));

    //DDR Modal
    // if (localStorage.getItem("isDDRShown") === null) {
    //   localStorage.setItem("isDDRShown", 0);
    // }
    // if (localStorage.getItem("isDDRShown") == 0) {
    //   if (!isMobile && window.chrome !== undefined) {
    //     setTimeout(() => {
    //       this.openDDR();
    //     }, 1500);
    //   }
    // }

    //Visit Count
    if (localStorage.getItem("visitCount") === null) {
      localStorage.setItem("visitCount", 1);
    }
    this.visitCount = parseInt(localStorage.getItem("visitCount")) + 1;
    localStorage.setItem("visitCount", this.visitCount);

    //Tweet Clicked
    if (localStorage.getItem("tweetClicked") === null) {
      localStorage.setItem("tweetClicked", 0);
    }
    this.tweetClicked = parseInt(localStorage.getItem("tweetClicked"));

    //Show Welcome Logic
    if (localStorage.getItem("hideWelcome") === null) {
      localStorage.setItem("hideWelcome", 0);
    }
    if (localStorage.getItem("hideWelcome") == 1 || this.visitCount > 3) {
      this.hideWelcome = true;
    }

    //Turn on for production
    this.palettes = _.orderBy(this.palettes, ["name"]);
    let defo = _.find(this.palettes, { id: "defo" });
    let defo2 = cloneDeep(defo);
    defo2.id = "defo2";
    this.palettes = _.reject(this.palettes, {
      id: "defo",
    });
    this.palettes.unshift(defo2);
    this.palettes.unshift(defo);
    this.paletteChunks = _.chunk(this.palettes, 3);
  },
  mounted() {
    this.$emit("updateHead");
  },
  methods: {
    ...mapMutations(["openDDR"]),
    closeWelcome: function () {
      localStorage.setItem("hideWelcome", 1);
      this.hideWelcome = true;
    },
    tweetClick: function () {
      this.$ga.event("tweet-click");
      localStorage.setItem("tweetClicked", 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.palettes-container {
  background: #3c40c6;
  color: #fff;
  width: 100%;
  float: left;
  display: block;
  font-family: "Barlow";
  background-image: url("~@/assets/stars-opacity.svg");
  .palettes-content {
    width: 1024px;
    margin: 0 auto;
  }
  .small-palettes {
    width: 100%;
    float: left;
    .small-palette {
      float: left;
      margin-right: auto;
      width: 30%;
      margin-right: 5%;
      margin-bottom: 40px;
      &:nth-child(3n) {
        margin-right: 0%;
      }
    }
  }
  a {
    color: #fff;
  }
}

@media (max-width: 600px) {
  .palettes-container {
    padding: 0px 30px;
    box-sizing: border-box;
    .palettes-content {
      width: 100%;
      .small-palettes {
        box-sizing: border-box;
        .small-palette {
          float: none;
          position: relative;
          width: 100%;
        }
      }
    }
  }
}

.ph2 {
  width: 100%;
  padding: 20px 20px;
  box-sizing: border-box;
  background: #0c2461;
  display: inline-block;
  border-radius: 4px;
  text-align: center;
  margin-bottom: 40px;
}

.fadeHeight-enter-active,
.fadeHeight-leave-active {
  transition: all 0.2s;
  max-height: 230px;
}
.fadeHeight-enter,
.fadeHeight-leave-to {
  opacity: 0;
  max-height: 0px;
}
</style>
<style >
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Palettes.vue